src/pages/project/workflow/components/CheckWorkflowService.vue 已删除 100644 → 0 + 0 − 60 已查看
<template>
  <div>
    <a-table :pagination="false" :columns="columns" size="small" row-key="service_id" :data-source="dataSource">
      <span slot="workflows" slot-scope="text, record">
        <span v-for="(item, index) in record.workflows" :key="index" class="custom-link" @click="onDetail(item)">{{ item.title }}</span>
      </span>
    </a-table>
    <a-alert style="margin: 4px 0" class="alert-info" message="以上服务存在于其他未完成的DEMO发布流程中" type="warning" show-icon />
  </div>
</template>

<script>
const columns = [
  {
    title: '服务ID',
    dataIndex: 'service_id',
    key: 'service_id',
    align: 'center',
    width: 80
  },
  {
    title: '服务',
    dataIndex: 'service_name',
    key: 'service_name'
  },
  {
    title: '流程',
    scopedSlots: { customRender: 'workflows' }
  }
];
export default {
  props: {
    dataSource: {
      type: [Array],
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns
    };
  },
  methods: {
    onDetail(record) {
      const route = this.$router.resolve({
        name: 'page:project:workflow:detail',
        query: { workflowId: record.id }
      });
      window.open(route.href, '_blank');
    }
  }
};
</script>
<style lang="less" scoped>
.custom-link {
  display: block;
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  cursor: pointer;
  color: #1890ff;
}
</style>
